import { Info } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";

interface IProps {
    title: string;
    info: string;
    noTooltip?: boolean;
}
const HeadingWithInfo = ({ title, info, noTooltip }: IProps) => {
    // Process info text to handle escaped newlines and render properly formatted content
    const renderTooltipContent = () => {
        // Replace literal \n string with actual newline characters
        const processedInfo = info.replace(/\\n/g, "\n");
        const lines = processedInfo.split("\n");

        return (
            <Box sx={{ maxWidth: "600px" }}>
                {lines.map((line, index) => (
                    <Typography
                        key={index}
                        variant='body2'
                        sx={{
                            lineHeight: 1.6,
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                        }}
                    >
                        {line}
                    </Typography>
                ))}
            </Box>
        );
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", maxWidth: "500px" }}>
            <Typography
                fontSize='2rem'
                fontWeight='bold'
                sx={{ color: (theme) => theme.palette.primary.dark }}
                mr={0.5}
            >
                {title}
            </Typography>
            {!noTooltip && (
                <Tooltip title={renderTooltipContent()} enterTouchDelay={0}>
                    <Info sx={{ color: (theme) => theme.palette.primary.dark }} />
                </Tooltip>
            )}
        </Box>
    );
};
export default HeadingWithInfo;
